import { INVITE_STATUSES, INVITE_TYPES } from "@/helpers/constants";

export default {
  /**
   * Check that user can accept table movement invites
   * @param state {Object}
   * @param getters {Object}
   * @return {Function}
   */
  canUserAcceptTableMovementInvites: (state, getters, rootState, rootGetters) => table => {
    return (
      rootGetters["room/activeRoom"].ACCEPT_USER_MOVEMENT_INVITES &&
      (table || rootGetters["tables/userTable"]).SEND_USER_MOVEMENT_INVITES
    );
  },

  /**
   * Sent Video invites
   * @return {function()}
   */
  sentTableMovementInvites: state => {
    return state.sentInvites.filter(invite => invite.inviteType === INVITE_TYPES.TABLE_MOVEMENT);
  },

  /**
   * Sent Video call invites
   * @return {function()}
   */
  sentVideoCallInvites: state => {
    return state.sentInvites.filter(invite => invite.inviteType === INVITE_TYPES.VIDEO_CALL);
  },

  /**
   * Check that user has active sent invites
   * @param state {Object}
   * @return {function(*, *)}
   */
  hasUserProcessingInvites: state => (inviteType, userUUID) => {
    return (
      state.sentInvitesUsersMap[inviteType] &&
      state.sentInvitesUsersMap[inviteType][userUUID] &&
      state.sentInvitesUsersMap[inviteType][userUUID].inviteStatus === INVITE_STATUSES.SEND
    );
  }
};
